import AddContributorModal from './AddContributorModal';

export default AddContributorModal;
